import { Text } from "../../../../atoms/Text";
import { cn } from "../../../../lib/cn";
import { formatQuantity } from "../../../../lib/quantity";

export interface QuantityProps {
  value: number;
  unitLabel: string;
  strike?: boolean;
  quiet?: boolean;
}

export const Quantity = ({
  value,
  unitLabel,
  strike = false,
  quiet = false,
}: QuantityProps) => (
  <Text
    as="span"
    variant="inherit"
    className={cn(
      "whitespace-nowrap tabular-nums",
      quiet
        ? "font-normal text-(length:--ledger-text-cell) leading-[1.66] text-content-secondary"
        : "font-semibold text-(length:--ledger-text-title) leading-[1.43] text-content-primary",
      strike && "line-through",
    )}
  >
    {formatQuantity(value, unitLabel)}
  </Text>
);
